class Daps {
    constructor() {
      this.id = null
      this.dataEmissao = ''
      this.ano = ''
      this.mes = ''
      this.dataFatoGerador = ''
      this.numeroNota = ''
      this.valorServico = 0
      this.valorDesconto = 0
      this.valorBaseCalculo = 0
      this.aliquota = 0
      this.valorIss = 0
      this.tipoRecolhimento = ''
      this.discriminacaoServico = ''
      this.idRegimeTributacao = ''
      this.origem = ''
      this.tipoNfse = ''
      this.codigoVerificacao = ''
      this.codigoVerificacaoOrigem = ''
      this.dataVigenciaInicial = ''
      this.dataVigenciaFinal = ''
      this.version = ''
      this.motivoRecusaDaps = '';

      // Joins...
      this.idCliente = null
      this.idUsuario = null
      this.idCntTomador = null
      this.idTomadorDados = null
      this.idPrestadorDados = null
      this.idServicoItem = null
      this.idMunicPrestacao = null
      this.idFichaRespostaPai = null
      this.idFluxoInstanciaAtividade = null
    }
  }
  
  export default Daps
  